import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';

@Component({
    selector: 'ngx-confirm-dialog',
    templateUrl: './confirm-dialog.component.html',
    styleUrls: ['./confirm-dialog.component.scss'],
    standalone: false
})
export class ConfirmDialogComponent implements OnInit {
  @Input() title: string;
  @Input() event: any;
  @Input() body: any;
  @Output() isClosed = new EventEmitter<boolean>(false);
  @Output() isSaved = new EventEmitter<boolean>(false);

  @Input() textOk: string = 'Yes';
  @Input() textNo: string = 'No';

  mainForm = new FormGroup({
    id: new FormControl(0),
    number: new FormControl(''),
  });

  constructor() { }

  ngOnInit() {
  }

  cancel() {
    this.isClosed.emit(true);
  }

  save() {
    this.isSaved.emit(true);
  }
}
